import { useState } from "react";
import { useNavigate } from "react-router-dom";

const faqs = [
  {
    id: 1,
    category: "工厂认证",
    categoryColor: "bg-orange-100 text-orange-600",
    question: "工厂入驻需要提交哪些资质证明？",
    answer: "工厂入驻需提交以下材料，缺一不可：① 营业执照彩色扫描件；② 生产许可证或行业资质证书；③ 第三方机构出具的产品质量检测报告；④ 法人身份证正反面；⑤ 统一社会信用代码。所有材料均由平台人工核验，确保工厂真实合法经营。",
  },
  {
    id: 2,
    category: "工厂认证",
    categoryColor: "bg-orange-100 text-orange-600",
    question: "为什么需要上传工厂和仓库的实景照片？",
    answer: "平台要求工厂上传真实的生产车间照片（至少5张）、仓库实景照片（至少3张）、工厂外观及门牌照片，以核验工厂确实具备生产能力和仓储条件。照片必须真实，不得使用他人工厂照片。对于大额订单工厂，平台保留实地走访核验的权利。",
  },
  {
    id: 3,
    category: "工厂认证",
    categoryColor: "bg-orange-100 text-orange-600",
    question: "工厂会员前3个月免费，之后费用是多少？",
    answer: "工厂入驻后前3个月完全免费，无需支付任何费用，也无需绑定银行卡。3个月免费期结束后，仅需每月 ¥5 的会员费即可继续享受所有工厂会员权益。可随时取消，不会自动扣费。",
  },
  {
    id: 4,
    category: "品牌保护",
    categoryColor: "bg-red-100 text-red-600",
    question: "为什么只允许销售自有品牌商品？",
    answer: "皇冠鸿运商城致力于打造正品直营平台，严禁任何形式的仿冒、山寨行为。所有工厂必须持有自己注册的商标证书，只能销售自有品牌商品。这样既保护了消费者权益，也保护了正规工厂的品牌价值，杜绝劣币驱逐良币。",
  },
  {
    id: 5,
    category: "品牌保护",
    categoryColor: "bg-red-100 text-red-600",
    question: "如果工厂销售仿冒品牌商品会有什么后果？",
    answer: "一旦发现工厂销售仿冒、山寨任何第三方品牌商品，平台将立即采取以下措施：① 下架全部商品；② 永久封号，不得再次申请；③ 公示违规工厂信息；④ 情节严重者移交工商、公安机关处理，承担相应法律责任。平台对此采取零容忍政策。",
  },
  {
    id: 6,
    category: "货款托管",
    categoryColor: "bg-green-100 text-green-600",
    question: "货款托管机制是如何运作的？",
    answer: "货款托管流程：① 买家下单付款，资金进入平台托管账户，工厂无法直接提取；② 工厂按时发货，提供高品质商品；③ 买家收货后验收商品质量；④ 买家确认收货且质量合格后，平台自动将货款释放给工厂。如买家对质量有异议，可在收货后7天内发起纠纷，平台介入调查后决定货款归属。",
  },
  {
    id: 7,
    category: "货款托管",
    categoryColor: "bg-green-100 text-green-600",
    question: "如果买家收到的商品质量不合格怎么办？",
    answer: "买家收货后7天内可发起质量纠纷申请。平台将介入调查，要求工厂提供质检报告和发货凭证，必要时委托第三方机构对商品进行检测。如确认商品质量不合格，平台将：① 退还买家全部货款；② 扣除工厂保证金；③ 视情节轻重暂停或永久取消工厂资格。",
  },
  {
    id: 8,
    category: "分销商计划",
    categoryColor: "bg-teal-100 text-teal-600",
    question: "分销商会员费用是多少？如何加入？",
    answer: "分销商会员完全免费，永久免费，无任何隐藏费用。加入步骤：① 注册皇冠鸿运商城账号；② 申请加入分销商计划（24小时内审核）；③ 获得专属推荐链接和推荐码；④ 分享给好友，好友购买即可获得佣金（白银10%、黄金12%、钻石15%）。",
  },
  {
    id: 9,
    category: "Crowntalk",
    categoryColor: "bg-red-100 text-red-500",
    question: "Crowntalk 是什么？国内手机能用吗？",
    answer: "Crowntalk 是皇冠鸿运商城官方全球社交通讯应用，支持与全球任何人进行文字、语音、高清视频通话，还可分享商城商品礼物。iOS 用户可在 App Store 搜索「Crowntalk」下载；国内华为、小米、OPPO、vivo 等安卓手机可直接下载 APK 安装包，无需 Google 服务，安装简单。",
  },
];

export default function FaqSection() {
  const navigate = useNavigate();
  const [openId, setOpenId] = useState<number | null>(1);
  const [activeCategory, setActiveCategory] = useState("全部");

  const categories = ["全部", "工厂认证", "品牌保护", "货款托管", "分销商计划", "Crowntalk"];

  const filtered = activeCategory === "全部"
    ? faqs
    : faqs.filter((f) => f.category === activeCategory);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <span className="inline-block bg-red-100 text-red-500 text-xs px-3 py-1 rounded-full mb-4 font-medium">
            <i className="ri-question-answer-line mr-1"></i> 常见问题
          </span>
          <h2
            className="text-3xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: "'Noto Serif SC', serif" }}
          >
            您可能想了解的问题
          </h2>
          <p className="text-gray-400 text-base max-w-xl mx-auto">
            关于工厂会员、分销商计划、Crowntalk 及购物保障的常见问题解答
          </p>
        </div>

        {/* Category filter */}
        <div className="flex items-center justify-center gap-2 mb-8 flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-red-500 text-white"
                  : "bg-white text-gray-500 hover:bg-gray-100"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-3">
            {filtered.map((faq) => (
              <div
                key={faq.id}
                className="bg-white rounded-2xl overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0 ${faq.categoryColor}`}>
                      {faq.category}
                    </span>
                    <span className="text-gray-800 font-semibold text-sm leading-snug">
                      {faq.question}
                    </span>
                  </div>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openId === faq.id ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line text-gray-400 text-lg"></i>
                  </div>
                </button>
                {openId === faq.id && (
                  <div className="px-5 pb-5">
                    <div className="border-t border-gray-100 pt-4">
                      <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA row */}
          <div className="mt-10 bg-gradient-to-r from-red-500 to-orange-500 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-white text-center sm:text-left">
              <p className="font-bold text-lg" style={{ fontFamily: "'Noto Serif SC', serif" }}>
                还有其他问题？
              </p>
              <p className="text-white/75 text-sm mt-1">
                工厂会员前3个月免费 · 分销商永久免费 · 立即加入
              </p>
            </div>
            <div className="flex gap-3 flex-shrink-0">
              <button
                onClick={() => navigate("/reseller-dashboard")}
                className="bg-white text-red-500 hover:bg-red-50 px-5 py-2.5 rounded-xl font-bold text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-add-line mr-1"></i>加入分销商
              </button>
              <button className="bg-white/20 hover:bg-white/30 text-white px-5 py-2.5 rounded-xl font-bold text-sm transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-customer-service-line mr-1"></i>联系客服
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
